import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../store';
import { fetchArqueosBaqueira, sendArqueoBaqueira } from '../actions/arqueosbaqueira'

class ArqueosBaqueiraList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        locker_name: '',
        end_date: '',
        status: '', // New status filter
      },
      loadingArqueoId: null, // Track which arqueo is being processed
    };
  }

  goTo(id, e) {
    history.push(`/arqueosbaqueira/${id}`);
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  // Function to handle JSON download
  downloadJson = (arqueo, e) => {
    e.stopPropagation(); // Prevent the row click event from being triggered

    const jsonString = JSON.stringify(arqueo, null, 2); // Convert to JSON string with indentation
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // Create a link and trigger a download
    const link = document.createElement('a');
    link.href = url;
    link.download = `arqueo-${arqueo.locker_name}-${new Date(arqueo.date).toLocaleDateString()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to send Arqueo Baqueira
  sendArqueoBaqueira = async (arqueo) => {
    this.setState({ loadingArqueoId: arqueo._id });

    try {
      // Simulate the API call
      const response = await this.props.sendArqueoBaqueira(arqueo._id);

      // Update the status in the arqueos array
      if (response) {
        // Refresh within the current month window when provided;
        // fall back to a full fetch otherwise.
        if (this.props.refreshArqueos) {
          this.props.refreshArqueos();
        } else {
          this.props.fetchArqueosBaqueira();
        }
      } else {
        // Handle failure if needed
        console.error("Error sending Arqueo:", response.message);
      }
    } catch (error) {
      console.error("Failed to send Arqueo:", error);
    } finally {
      // Stop loading
      this.setState({ loadingArqueoId: null });
    }
  };

  render() {
    const { filters, loadingArqueoId } = this.state;
    const { arqueosbaqueira } = this.props;

    // Distinct zones present in the loaded data (for the zone select)
    const zones = [...new Set(arqueosbaqueira.map(a => a.locker_name).filter(Boolean))].sort();
    // Keep the select consistent if the current selection is not in this month's data
    if (filters.locker_name && !zones.includes(filters.locker_name)) {
      zones.push(filters.locker_name);
    }

    // Apply filters to filter the arqueos array
    const filteredArqueos = arqueosbaqueira.filter(arqueo => {
      const { locker_name, end_date, status } = filters;

      // Apply the locker_name filter (exact match — values come from the select)
      if (locker_name && arqueo.locker_name !== locker_name) {
        return false;
      }

      // Apply the end_date filter
      if (end_date && new Date(arqueo.date).toLocaleDateString() !== new Date(end_date).toLocaleDateString()) {
        return false;
      }

      // Apply the status filter
      if (status) {
        const isStatusTrue = status === 'true';
        if (arqueo.status !== isStatusTrue) {
          return false;
        }
      }

      return true;
    });

    return (
      <>
        {/* Filter bar */}
        <div className="abq-filterbar">
          <div className="abq-filter">
            <label>Fecha de Arqueo</label>
            <input
              type="date"
              value={filters.end_date}
              onChange={e => this.handleFilterChange('end_date', e.target.value)}
            />
          </div>
          <div className="abq-filter">
            <label>Zona</label>
            <select
              value={filters.locker_name}
              onChange={e => this.handleFilterChange('locker_name', e.target.value)}
            >
              <option value="">Todas</option>
              {zones.map(zone => (
                <option value={zone} key={zone}>{zone}</option>
              ))}
            </select>
          </div>
          <div className="abq-filter">
            <label>Sudiba ERP</label>
            <select
              value={filters.status}
              onChange={e => this.handleFilterChange('status', e.target.value)}
            >
              <option value="">Todas</option>
              <option value="true">Correctas</option>
              <option value="false">Fallidas</option>
            </select>
          </div>
        </div>

        {/* Row-card list */}
        <div className="abq-list">
          {filteredArqueos.length === 0 && (
            <div className="abq-empty">
              <i className="fas fa-inbox mr-2"></i>
              No hay arqueos que coincidan con los filtros
            </div>
          )}
          {filteredArqueos
            .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
            .map(arqueo => (
              <div key={arqueo._id} className="abq-rowcard" onClick={e => this.goTo(arqueo._id, e)}>
                <div className="abq-rowcard-main">
                  <div className="abq-rowcard-name">
                    <i className="fas fa-cash-register"></i>
                    {arqueo.locker_name}
                  </div>
                  <span className="abq-date">
                    <i className="far fa-calendar-alt"></i>
                    {new Date(arqueo.date).toLocaleDateString()}
                  </span>
                </div>
                <div className="abq-rowcard-params">
                  <div className="abq-param">
                    <span className="abq-label">Sudiba ERP</span>
                    <button
                      type="button"
                      className={`abq-badge ${arqueo.status ? 'success' : 'danger'}`}
                      title="Ver respuesta"
                      onClick={e => {
                        e.stopPropagation(); // Prevent row click event
                        alert(`Response: ${arqueo.response}`); // Display arqueo.response in a browser message
                      }}
                    >
                      <i className={`fas ${arqueo.status ? 'fa-check' : 'fa-exclamation-triangle'}`}></i>
                      {arqueo.status === true ? 'Correcta' : arqueo.status === false ? 'Fallida' : 'None'}
                    </button>
                  </div>
                </div>
                <div className="abq-rowcard-actions">
                  <button
                    className="abq-btn abq-btn-download"
                    onClick={e => this.downloadJson(arqueo, e)}
                  >
                    <i className="fas fa-download"></i>
                    Descargar
                  </button>
                  {arqueo.status === false ? (
                    loadingArqueoId === arqueo._id ? (
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Ejecutando...</span>
                      </div>
                    ) : (
                      <button
                        className="abq-btn abq-btn-send"
                        onClick={e => {
                          e.stopPropagation();
                          this.sendArqueoBaqueira(arqueo);
                        }}
                      >
                        <i className="fas fa-paper-plane"></i>
                        Enviar
                      </button>
                    )
                  ) : (
                    <button className="abq-btn abq-btn-sent" disabled>
                      <i className="fas fa-check"></i>
                      Enviado
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
      </>
    );
  }
}

// Example of connecting Redux actions
const mapDispatchToProps = (dispatch) => ({
  sendArqueoBaqueira: bindActionCreators(sendArqueoBaqueira, dispatch),
  fetchArqueosBaqueira: bindActionCreators(fetchArqueosBaqueira, dispatch),
});

export default connect(null, mapDispatchToProps)(ArqueosBaqueiraList);
